// AUTO-GENERATED by /app/frontend/scripts/generate-build-info.js
// Do not edit by hand; this file is regenerated on every `yarn start` /
// `yarn build`.

export const BUILD_VERSION = "v2026.11.03-1954";
export const BUILD_SHA = "";
export const BUILD_TIME_ISO = "2026-11-03T19:54:03.665Z";
